import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class ClientesService  extends CommonService{
    getClientes(page,qntd,id_empresa) {
        let url = `clientes/cliente/${id_empresa}?_page=${page}&_pagesize=${qntd}`;
        // https://app.motorfiscal.com.br/teste/fornecedores/fornecedor/5b4cc42de471d50362ddce00
        return this._resource.get(url).then(success => {
                return success.body;
        },
            failed => {
                return failed;
            })
    }
}


// WEBPACK FOOTER //
// ./src/domain/clientes/ClientesService.js